(function($) {
	$(function() {
		$('[data-fancybox]').fancybox({
			margin: 0,
			animationEffect: 'fade',
			beforeShow: function(){
				$('.fancybox-container').addClass('simple-popup');
			}
		});
	});
})(jQuery);